{
  "eyebrow": "Confirma tu plan",
  "title": "Revisa y configura.",
  "sub": "Puedes cambiar el ciclo de facturación o el plan en cualquier momento desde tu panel de administración.",
  "yourPlan": "Tu plan",
  "changePlan": "Cambiar plan",
  "billing": "Ciclo de facturación",
  "billingMonthLabel": "Pago mensual",
  "billingMonthDesc": "Flexible. Cancela cuando quieras.",
  "billingYearLabel": "Pago anual",
  "billingYearDesc": "15% de descuento. Facturación anual única.",
  "addons": "Complementos",
  "addon": {
    "ssec": "Seguridad social (check-in/out@work)",
    "ssecDesc": "Solo Bélgica — declaración Dimona automática.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "GPS en vivo para vehículos de empresa. +4,80 €/vehículo/mes.",
    "vehicles": "Vehículos"
  },
  "users": {
    "title": "¿Cuántos usuarios necesitas?",
    "help": "Cada persona que utilice Done-it cuenta como un usuario, incluidos administradores y empleados.",
    "active": "usuarios"
  },
  "estimate": "Coste mensual estimado",
  "estimateNote": "IVA no incluido. Paga por el número de usuarios que indique aquí y podrá cambiarlo más adelante.",
  "estimateUnavailable": "Catálogo de precios no disponible. Reintenta para cargar los precios más recientes."
}
